// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yk-1";
export var printerIcon = "_yk-0";